import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { 
	faArrowRight as fasArrowRight
 } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, FormDecidable } from "bm-ui-kit";
import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import React from "react";
import { Card } from "react-bootstrap";

export interface StepFields {
	hasLessThanOneClosedYear: boolean;
	hasNegativeIncomeAfterTaxation: boolean;
	hasOverdueNavDebt: boolean;
	hasOverdueLoanDebt: boolean;
	ownerInKhr: boolean;
}

export class StepB2 extends AbstractStep<StepFields> {
	protected renderContent(_values: StepFields, form: FormApi<StepFields>): ReactNode {
		return (
			<>
				<Card.Body>
					<FormDecidable
						label="Céged kevesebb gazdasági múlttal rendelkezik, mint 1 teljes lezárt pénzügyi év?"
						name="hasLessThanOneClosedYear"
						required
					/>
					<FormDecidable
						label="A vállalkozás adózás utáni jövedelme negatív?"
						name="hasNegativeIncomeAfterTaxation"
						required
					/>
					<FormDecidable label="Van lejárt NAV tartozása a cégednek?" name="hasOverdueNavDebt" required />
					<FormDecidable label="Van a cégednek lejárt hiteltartozása?" name="hasOverdueLoanDebt" required />
					<FormDecidable
						label="Mint magánszemély, illetve a készfizető kezes szerepel a KHR/BAR listán?"
						name="ownerInKhr"
						required
					/>
				</Card.Body>
				<Card.Footer className="text-center">
					<Button
						type="submit"
						icon={<FontAwesomeIcon icon={fasArrowRight} />}
						className={!form.getState().valid ? "disabled" : undefined}
					>
						Tovább
					</Button>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "StepB2";
	}
}
